// src/locales/si/paymentVerification.js
import { paymentVerification as paymentVerificationEn } from '../en/paymentVerification';

export const paymentVerification = {
  ...paymentVerificationEn,
  pageTitle: "ගෙවීම් තහවුරු කිරීම",
  pageDescription: "කාර්ය මණ්ඩලය ඉදිරිපත් කළ ගෙවීම් වාර්තා සමාලෝචනය කර තහවුරු කරන්න",
  orderNumber: "ඇණවුම් අංකය",
  paymentMethod: "ගෙවීම් ක්‍රමය",
  paymentType: "ගෙවීම් වර්ගය",
  amount: "මුදල",
  reference: "ගෙවීම් යොමුව",
  paymentDate: "ගෙවීම් දිනය",
  proof: "ගොනුව",
  isVerified: "තහවුරු කර ඇත්ද",
  action: "ක්‍රියාව",
  createdBy: "සෑදුවේ",
  createdDate: "සාදන ලද දිනය",
  verifiedBy: "තහවුරු කළේ",
  verifiedDate: "තහවුරු කළ දිනය",
  voidedBy: "අවලංගු කළේ",
  voidedDate: "අවලංගු කළ දිනය",
  verified: "තහවුරු කර ඇත",
  unverified: "තහවුරු කර නැත",
  issues: "ගැටළු",
  void: "අවලංගු",
  allPaymentMethods: "සියලුම ගෙවීම් ක්‍රම",
  allPaymentTypes: "සියලුම ගෙවීම් වර්ග",
  allStatuses: "සියල්ල",
  verifiedOnly: "තහවුරු කළ",
  unverifiedOnly: "තහවුරු නොකළ",
  searchPlaceholder: "ඇණවුම් අංකය හෝ යොමුව අනුව සොයන්න...",
  noFileChosen: "ගොනුවක් තෝරා නැත",
  viewProof: "බලන්න",
  viewProofPdf: "උඩුගත කළ PDF බලන්න",
  changeProof: "වෙනස් කරන්න",
  deleteProof: "මකන්න",
  confirmDeleteProof: "මෙම වාර්තාව සඳහා උඩුගත කළ ගෙවීම් සාක්ෂිය ඉවත් කරන්නද?",
  verify: "තහවුරු කරන්න",
  save: "සුරකින්න",
  verifySelected: "තෝරාගත් ඒවා තහවුරු කරන්න ({count})",
  clearSelection: "තේරීම ඉවත් කරන්න",
  confirmVerify: "මෙම ගෙවීම් වාර්තාව තහවුරු කළ ලෙස සලකුණු කරන්නද?",
  confirmBulkVerify: "තෝරාගත් ගෙවීම් වාර්තා {count} ක් තහවුරු කරන්නද? මෙය ආපසු හැරවිය නොහැක.",
  confirmVoid: "අවලංගු කිරීමෙන් මෙම ගෙවීම් වාර්තාව අවලංගු වේ. මෙය ඇණවුමේ ගෙවූ මුදල වෙනස් නොකරයි.",
  voidReasonLabel: "අවලංගු කිරීමට හේතුව",
  flagAsIssue: "ගැටළුවක් ලෙස සලකුණු කරන්න",
  flagIssueDescription: "ඇමතුම් මධ්‍යස්ථාන කාර්ය මණ්ඩලයට පාරිභෝගිකයා සමඟ පසු විපරම් කිරීමට මෙම ගෙවීම් වාර්තාව ගැටළුවක් ලෙස සලකුණු කරන්න.",
  flagIssueReasonLabel: "ගැටළුව විස්තර කරන්න",
  resolve: "විසඳන්න",
  resolveDescription: "ගැටළුව විසඳූ පසු මෙම ගෙවීම් වාර්තාව නැවත තහවුරු නොකළ තත්ත්වයට ගෙන යන්න.",
  resolveNoteLabel: "විසඳුම් සටහන (විකල්ප)",
  notes: "සටහන්",
  addNote: "සටහනක් එක් කරන්න",
  notePlaceholder: "මෙම ගෙවීම් වාර්තාව ගැන සටහනක් එක් කරන්න...",
  noNotesYet: "තවම සටහන් නැත",
  verifySuccess: "ගෙවීම් වාර්තාව සාර්ථකව තහවුරු කරන ලදී",
  verifyFailed: "ගෙවීම් වාර්තාව තහවුරු කිරීමට අසමත් විය",
  bulkVerifySuccess: "ගෙවීම් වාර්තා {count} ක් සාර්ථකව තහවුරු කරන ලදී",
  bulkVerifyPartial: "වාර්තා {totalSubmitted} න් {successCount} ක් තහවුරු කරන ලදී; {failureCount} ක් අසමත් විය",
  bulkVerifyFailed: "තෝරාගත් ගෙවීම් වාර්තා තහවුරු කිරීමට අසමත් විය",
  updateSuccess: "ගෙවීම් වාර්තාව සාර්ථකව යාවත්කාලීන කරන ලදී",
  updateFailed: "ගෙවීම් වාර්තාව යාවත්කාලීන කිරීමට අසමත් විය",
  proofUploadFailed: "ගෙවීම් සාක්ෂිය උඩුගත කිරීමට අසමත් විය",
  cannotEditVerified: "තහවුරු කළ වාර්තා සංස්කරණය කළ නොහැක",
  noUnverifiedSelected: "අවම වශයෙන් එක් තහවුරු නොකළ වාර්තාවක් තෝරන්න",
  failedToLoad: "ගෙවීම් වාර්තා පූරණය කිරීමට අසමත් විය",
  noRecordsFound: "ගෙවීම් වාර්තා හමු නොවීය",
  noRecordsFoundDescription: "ඔබගේ සෙවුම් නිර්ණායකවලට ගැළපෙන ගෙවීම් වාර්තා නැත",
  voidSuccess: "ගෙවීම් වාර්තාව සාර්ථකව අවලංගු කරන ලදී",
  voidFailed: "ගෙවීම් වාර්තාව අවලංගු කිරීමට අසමත් විය",
  flagIssueSuccess: "ගෙවීම් වාර්තාව ගැටළුවක් ලෙස සලකුණු කරන ලදී",
  flagIssueFailed: "ගෙවීම් වාර්තාව සලකුණු කිරීමට අසමත් විය",
  resolveSuccess: "ගෙවීම් වාර්තාවේ ගැටළුව විසඳන ලදී",
  resolveFailed: "ගෙවීම් වාර්තාවේ ගැටළුව විසඳීමට අසමත් විය",
  noteAddSuccess: "සටහන සාර්ථකව එක් කරන ලදී",
  noteAddFailed: "සටහන එක් කිරීමට අසමත් විය",
  notesLoadFailed: "සටහන් පූරණය කිරීමට අසමත් විය",
  referenceRequiredForBankTransfer: "බැංකු මාරු ගෙවීමක් තහවුරු කිරීමට ගෙවීම් යොමුව අවශ්‍යයි",
  saveChangesBeforeVerify: "මෙම ගෙවීම තහවුරු කිරීමට පෙර ඔබගේ වෙනස්කම් සුරකින්න",
  bulkUnsavedChanges: "තෝරාගත් ගෙවීම් වාර්තා {count} ක සුරැකීමට නොමැති වෙනස්කම් ඇත. තහවුරු කිරීමට පෙර ඒවා සුරකින්න.",
  bulkReferenceMissing: "තෝරාගත් බැංකු මාරු ගෙවීම් {count} කට ගෙවීම් යොමුවක් නොමැත. තහවුරු කිරීමට පෙර යොමු එක් කරන්න.",
};
